export function loadGoogleAnalytics() {
  if (document.getElementById('ga-script')) return;

  const script1 = document.createElement('script');
  script1.id = 'ga-script';
  script1.async = true;
  script1.src = "https://www.googletagmanager.com/gtag/js?id=G-SXM8KF74RK";
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-SXM8KF74RK');
  `;
  document.head.appendChild(script2);
}
